<template>
    <div class="fill-height of-y d-flex flex-column" @scroll="showClassificationMenu = false">
        <div class="d-flex align-center px-8 flex-wrap" v-if="loading || !stats.employeePerformance.length">
            <template v-for="employee in employees">
                <v-btn
                        :key="employee._id"
                        color="primary"
                        small
                        text
                        @click="gotoEmployee(employee._id)"
                >
                    <v-icon left>mdi-account</v-icon>
                    {{ employee.name }}
                </v-btn>
            </template>
        </div>

        <v-scroll-x-transition hide-on-leave>
            <app-centre-loader v-if="loading" label="Fetching Data"/>
        </v-scroll-x-transition>

        <v-scroll-x-transition hide-on-leave>
            <div class="flex-grow-1 d-flex align-center justify-center" v-if="!loading && !stats.employeePerformance.length">
                <div class="text-overline amber--text text-center">
                    No data for the selected date range
                    <br>
                    Please select another date or range
                </div>
            </div>
        </v-scroll-x-transition>

        <v-scroll-x-transition hide-on-leave>
            <div v-if="!loading && stats.employeePerformance.length" class="d-flex flex-column of-y flex-grow-1" >

                <div class="flex-grow-1 of-y d-flex flex-column" @scroll="showClassificationMenu = false">

                    <div class="d-flex align-center px-8 flex-wrap">
                        <template v-for="employee in employees">
                            <v-btn
                                    :key="employee._id"
                                    color="primary"
                                    small
                                    text
                                    @click="gotoEmployee(employee._id)"
                            >
                                <v-icon left>mdi-account</v-icon>
                                {{ employee.name }}
                            </v-btn>
                        </template>
                    </div>

<!--Statistics-->
                    <app-divider label="Statistics" show-expanded :expanded.sync="statisticsShown" ></app-divider>
                    <v-scroll-y-transition hide-on-leave>
                        <div class="d-flex align-start justify-space-around flex-wrap px-10 pt-4" v-if="statisticsShown">
                            <template v-for="card in shownCards">
                                <v-card class="mb-4 mx-2" width="300" :key="card.key" style="position: relative">

                                    <div class="pa-2 grey--text" style="position: absolute; right: 0; top: 0">
                                        {{ card.valDesc }}
                                    </div>

                                    <div class="pa-2">
                                        <div class="body-2">
                                            {{ card.info.text }}
                                        </div>
                                        <div class="caption grey--text">
                                            {{ card.info.description }}
                                        </div>
                                    </div>

                                    <div class="px-4 pb-2 text-h5 text-end">
                                        {{ card.val }}
                                    </div>
                                    <div>
                                        {{ card.val2 }}
                                    </div>
                                </v-card>
                            </template>
                        </div>
                    </v-scroll-y-transition>

<!--Employee Statistics-->
                    <app-divider
                            label="Employee Statistics"
                            class="pt-4" show-expanded
                            :expanded.sync="employeeStatisticsShown"
                            :show-search="true"
                            :search.sync="employeeFilter"
                    >
                        <template v-slot:action>
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            icon
                                            color="primary"
                                            class="mx-2"
                                            small
                                            @click="showSelectEmployeeStatsColumns = true"
                                            v-on="on"
                                    >
                                        <v-icon>mdi-view-column</v-icon>
                                    </v-btn>
                                </template>
                                Select Columns
                            </v-tooltip>
                        </template>

                    </app-divider>
                    <app-employee-stats-select-columns-dlg
                            v-if="showSelectEmployeeStatsColumns"
                            :shown.sync="showSelectEmployeeStatsColumns"
                    />
                    <v-scroll-y-transition hide-on-leave>
                        <v-card class="mx-12 mt-2" v-if="employeeStatisticsShown">
                            <v-data-table
                                    ref="grid"
                                    :headers="viewColumns"
                                    :items="stats.employeeStatistics"
                                    :search="employeeFilter"
                                    :items-per-page="stats.employeeStatistics.length"
                                    hide-default-footer
                                    class="full-table"
                                    @click:row="gotoEmployee($event._id)"
                                    :sortBy.sync="$store.state.sortPreference.teamStats.employeeStatistics.by"
                                    :sort-desc.sync="$store.state.sortPreference.teamStats.employeeStatistics.order"
                            >
                                <template v-slot:item.employeeName="{ item }">
                                    <div class="d-flex align-center overline" style="white-space: nowrap">
                                        <v-icon left small>mdi-account</v-icon>
                                        {{ item.employeeName }}
                                    </div>
                                </template>
                                <template v-slot:item.teamName="{ item }">
                                    <v-btn
                                            small
                                            text
                                            color="primary"
                                            @click.stop="gotoTeam(item.teamId)"
                                    >
                                        <v-icon left>mdi-account-group</v-icon>
                                        {{ item.teamName }}
                                    </v-btn>
                                </template>
                                <template v-slot:item.workTime="{ item }">{{ hourDisplay(item.workTime, true) }}</template>
                                <template v-slot:item.activeTime="{ item }">{{ hourDisplay(item.activeTime, true) }}</template>

                                <!--                        <template v-slot:header.activeTime="{header}">-->
                                <!--                            <div class="b1" style="width: 150px">-->
                                <!--                                {{header.text}}123456-->
                                <!--                            </div>-->
                                <!--                        </template>-->

                                <template v-slot:item.ptt="{ item }">{{ hourDisplay(item.ptt, true) }}</template>
                                <template v-slot:item.ptn="{ item }">{{ hourDisplay(item.ptn, true) }}</template>
                                <template v-slot:item.pto="{ item }">{{ hourDisplay(item.pto, true) }}</template>
                                <template v-slot:item.utt="{ item }">{{ hourDisplay(item.utt, true) }}</template>
                                <template v-slot:item.utn="{ item }">{{ hourDisplay(item.utn, true) }}</template>
                                <template v-slot:item.uto="{ item }">{{ hourDisplay(item.uto, true) }}</template>
                                <template v-slot:item.ntt="{ item }">{{ hourDisplay(item.ntt, true) }}</template>
                                <template v-slot:item.ntn="{ item }">{{ hourDisplay(item.ntn, true) }}</template>
                                <template v-slot:item.nto="{ item }">{{ hourDisplay(item.nto, true) }}</template>
                                <template v-slot:item.ttt="{ item }">{{ hourDisplay(item.ttt, true) }}</template>
                                <template v-slot:item.idleTime="{ item }">{{ hourDisplay(item.idleTime, true) }}</template>
                                <template v-slot:item.productivityTarget="{ item }">{{ percentDisplay(item.productivityTarget) }}</template>
                                <template v-slot:item.productivityActive="{ item }">{{ percentDisplay(item.productivityActive) }}</template>
                                <template v-slot:item.productivityWorkTime="{ item }">{{ percentDisplay(item.productivityWorkTime) }}</template>
                                <template v-slot:item.productivityNormalTarget="{ item }">
                                    {{ percentDisplay(item.productivityNormalTarget) }}
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-btn
                                            color="primary"
                                            class="mx-2"
                                            small
                                            icon
                                            @click.stop="gotoEmployeeSettings(item._id)"
                                    >
                                        <v-icon>mdi-cog</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-scroll-y-transition>
<!--Screenshots-->
                    <template v-if="access.screenshots">
                        <app-divider label="Screenshots" show-expanded :expanded.sync="screenshotsShown" ></app-divider>
                        <v-scroll-y-transition hide-on-leave>
                            <app-screenshot-preview v-if=screenshotsShown :filter="{teamIds: [team._id]}"/>
                        </v-scroll-y-transition>
                    </template>

<!--Time Performance-->
                    <app-divider label="Time / Activity Breakdown" class="pt-4" show-expanded :expanded.sync="timePerformanceShown"></app-divider>
                    <v-scroll-y-transition hide-on-leave>
                        <div style="width: 100%; max-height: 500px" class="px-12 pt-4" v-if="timePerformanceShown">
                            <apex-chart height="300" type="line" :options="timePerformanceChartData.chartOptions"
                                        :series="timePerformanceChartData.series" ></apex-chart>
                        </div>
                    </v-scroll-y-transition>

<!--Employee Performance-->
                    <app-divider label="Employee Performance" class="pt-4" show-expanded :expanded.sync="employeePerformanceShown"></app-divider>
                    <v-scroll-y-transition hide-on-leave>
                        <div style="width: 100%; max-height: 500px" class="px-12 pt-4" v-if="employeePerformanceShown">
                            <apex-chart height="300" type="bar" :options="employeePerformanceChartData.chartOptions"
                                        :series="employeePerformanceChartData.series"></apex-chart>
                        </div>
                    </v-scroll-y-transition>
<!--Top Apps-->
                    <app-divider label="Top Apps" show-expanded :expanded.sync="topAppsShown" class="pt-4"></app-divider>
                    <v-scroll-y-transition hide-on-leave>
                        <div class="d-flex flex-wrap flex-grow-1" v-if="topAppsShown">
                            <div class="flex-grow-1 flex-equal " style="min-width: 500px;">
                                <v-data-table
                                        :headers="topAppTableHeadersWithAccess"
                                        :items="stats.topApps"
                                        :items-per-page="stats.topApps.length"
                                        hide-default-footer
                                        @click:row="gotoAppStats($event.match)"
                                        :sortBy.sync="$store.state.sortPreference.teamStats.topApps.by"
                                        :sort-desc.sync="$store.state.sortPreference.teamStats.topApps.order"
                                >
                                    <template v-slot:item.match="{ item }">
                                        <div class="d-flex align-center overline">
                                            <app-icon :match="item.match" left small/>
                                            {{ item.match }}
                                        </div>
                                    </template>
                                    <template v-slot:item.totalDuration="{ item }">{{
                                            hourDisplay(item.totalDuration, true)
                                        }}
                                    </template>
                                    <template v-slot:item.label="{ item }">
                                        <div class="d-flex align-center">
                                            <v-icon small :color="labelsRef[item.label].color" left>
                                                {{ labelsRef[item.label].icon }}
                                            </v-icon>
                                            <div class="body-2 d-flex align-center" :class="`${labelsRef[item.label].color}--text`">{{
                                                    labelsRef[item.label].text
                                                }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn
                                                color="primary"
                                                class="mx-2"
                                                small
                                                icon
                                                :loading="loadingClassifications.includes(item.match)"
                                                @click.stop="classificationMenuClicked($event, item)"
                                        >
                                            <v-icon>mdi-cog</v-icon>
                                        </v-btn>
                                    </template>

                                </v-data-table>
                            </div>
                            <div class="d-flex justify-center fill-height flex-grow-1 flex-equal "
                                 style="min-width: 500px">
                                <div class="flex-grow-1 flex-equal">
                                    <div class="text-center subtitle-1">
                                        Top Apps Usage
                                    </div>
                                    <apex-chart type="donut" :options="topAppsChartData.chartOptions"
                                                :series="topAppsChartData.seriesData"></apex-chart>
                                </div>
                                <div class="flex-grow-1 flex-equal">
                                    <div class="text-center subtitle-1">
                                        Productivity Distribution
                                    </div>
                                    <apex-chart type="radialBar" :options="productivityChartData.chartOptions"
                                                :series="productivityChartData.seriesData"></apex-chart>
                                </div>
                            </div>
                        </div>
                    </v-scroll-y-transition>

                </div>

            </div>
        </v-scroll-x-transition>

        <app-dlg
                v-if="$store.state.ref.teamStats.showCardsSelection"
                :show-dlg.sync="$store.state.ref.teamStats.showCardsSelection"
                title="Select Columns"
                :default-padding="false"
        >

            <app-list
                    v-model="$store.state.ref.teamStats.selectedCards"
                    :items="cards"
                    :multiple="true"
                    headline-key="text"
                    item-key="value"
                    sub-line-key="description"
                    :show-check-boxes="true"
                    :return-object="false"
                    class="fill-height of-y"
                    :height="400"
                    @input="updateSelections"
            />

            <template v-slot:actions>
                <v-btn
                        @click="$store.state.ref.teamStats.selectedCards = [...$store.state.defaultSelections.teamStats]; updateSelections()"
                        small
                        class="ml-2"
                        color="blue"
                        outlined
                        size="small"
                >
                    Reset Selections
                </v-btn>
                <v-btn
                        @click="$store.state.ref.teamStats.showCardsSelection = false"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                >
                    Done
                </v-btn>
            </template>
        </app-dlg>

        <v-menu
                v-if="showClassificationMenu"
                v-model="showClassificationMenu"
                :position-x="classificationX"
                :position-y="classificationY"
                absolute
                offset-y
                :max-width="200"
                :min-width="200"
        >
            <v-card>
                <v-list dense>
                    <v-list-item-group
                            :value="selectedClassification.label"
                            color="primary"
                    >
                        <v-list-item
                                v-for="label in labels"
                                :value="label.id"
                                :key="label.id"
                                @click="changeLabel(label.id)"
                                active-color="primary"
                        >
                            <v-list-item-content>
                                <v-list-item-title v-text="label.text"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                    <v-list-item
                            @click="gotoApp(selectedClassification.match)"
                            active-color="primary"
                    >
                        <v-list-item-content>
                            <v-list-item-title>More Options</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>

        <app-classification-dlg
                ref="classificationDlg"
                @future="saveClassificationLabelChangesConfirm()"
                @history="saveClassificationLabelChangesConfirm(true)"
        />
    </div>
</template>

<script>


import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {
    percentDisplay,
    hourDisplay,
    durationDisplay,
    isValidUrl,
    nameSort,
    arrSplice,
    durationDisplayFull
} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions, mapGetters} from "vuex";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import AppOutlinedChip from "@/components/Shared/AppOutlinedChip";
import VueApexCharts from 'vue-apexcharts'
import {format, isSameDay, isSameMonth, isSameYear} from "date-fns";
import AppScreenshotPreview from "@/components/Shared/Screenshots/AppScreenshotPreview";
import AppIcon from "@/components/Shared/AppIcon";
import AppEmployeeStatsSelectColumnsDlg from "@/components/Dashboard/AppEmployeeStatsSelectColumnsDlg";
import AppClassificationDlg from "@/components/Shared/AppClassificationDlg";
import {StatusMap} from "@/models/statusMap";

export default {
    components: {
        AppClassificationDlg,
        AppEmployeeStatsSelectColumnsDlg,
        AppIcon, AppScreenshotPreview, AppOutlinedChip, AppDivider, AppList, AppDlg, AppCentreLoader, apexChart: VueApexCharts},
    props: {},
    data() {
        return {
            isValidUrl,
            statisticsShown: true,
            topAppsShown: true,
            employeePerformanceShown: true,
            timePerformanceShown: true,
            screenshotsShown: true,
            employeeStatisticsShown: true,
            hourDisplay,
            percentDisplay,
            durationDisplay,
            loading: false,
            stats: {
                summary: null,
                topApps: [],
                employeePerformance: [],
                employeeStatistics: [],
                timePerformance: []
            },
            cards: [
                {text: 'Active Time', value: 'activeTime', description: 'Total time active'},
                {text: 'Productive', value: 'ptt', description: 'Total time productive'},
                {text: 'Productive Normal', value: 'ptn', description: 'Time productive during working hours'},
                {text: 'Productive Overtime', value: 'pto', description: 'Time productive outside of working hours'},
                {text: 'Unproductive', value: 'utt', description: 'Total time unproductive'},
                {text: 'Unproductive Normal', value: 'utn', description: 'Time unproductive during working hours'},
                {
                    text: 'Unproductive Overtime',
                    value: 'uto',
                    description: 'Time unproductive outside of working hours'
                },
                {text: 'Neutral', value: 'ntt', description: 'Total time neutral'},
                {text: 'Neutral Normal', value: 'ntn', description: 'Time neutral during working hours'},
                {text: 'Neutral Overtime', value: 'nto', description: 'Time neutral outside of working hours'},
                {text: 'Target', value: 'ttt', description: 'Total target duration'},
                {text: 'Idle', value: 'idleTime', description: 'Total idle duration'},
                {text: 'Productive Target %', value: 'productivityTarget', description: 'Total productivity vs total target'},
                {text: 'Productive Normal Target %', value: 'productivityNormalTarget', description: 'Total productivity in working hours vs total target'},
                {
                    text: 'Productive Active %',
                    value: 'productivityActive',
                    description: 'Total productivity vs total active'
                },
                // {
                //     text: 'Productive Work Time %',
                //     value: 'productivityWorkTime',
                //     description: 'Total productivity vs total work time'
                // },
            ],
            topAppTableHeaders: [
                {text: 'Name', value: 'match'},
                {text: 'Total Duration', value: 'totalDuration'},
                {text: 'Label', value: 'label'},
            ],
            employeeFilter: null,
            showSelectEmployeeStatsColumns: false,
            employeeStatisticsHeaders: [
                {text: 'Name', value: 'employeeName', description: 'Employee name'},
                {text: 'Active Time', value: 'activeTime', description: 'Total time active'},
                {text: 'Productive', value: 'ptt', description: 'Total time productive'},
                {text: 'Productive Normal', value: 'ptn', description: 'Time productive during working hours'},
                {text: 'Productive Overtime', value: 'pto', description: 'Time productive outside of working hours'},
                {text: 'Unproductive', value: 'utt', description: 'Total time unproductive'},
                {text: 'Unproductive Normal', value: 'utn', description: 'Time unproductive during working hours'},
                {text: 'Unproductive Overtime', value: 'uto', description: 'Time unproductive outside of working hours'},
                {text: 'Neutral', value: 'ntt', description: 'Total time neutral'},
                {text: 'Neutral Normal', value: 'ntn', description: 'Time neutral during working hours'},
                {text: 'Neutral Overtime', value: 'nto', description: 'Time neutral outside of working hours'},
                {text: 'Target', value: 'ttt', description: 'Total target duration'},
                {text: 'Idle', value: 'idleTime', description: 'Total idle duration'},
                {text: 'Productive Target %', value: 'productivityTarget', description: 'Total productivity vs total target'},
                {text: 'Productive Active %', value: 'productivityActive', description: 'Total productivity vs total active'},
                {text: 'Productive Normal Target %', value: 'productivityNormalTarget', description: 'Total productivity in working hours vs total target'},
            ],

            loadingClassifications: [],
            showClassificationMenu: false,
            selectedClassification: null,
            selectedClassificationNewLabel: null,
            classificationX: 0,
            classificationY: 0,
        }
    },
    watch: {
        "$store.state.ref.dashboard.selectedRange.start": {
            immediate: true,
            handler(val) {
                this.refreshData()
            }
        },
        devicesWithAccessIds() {
            this.refreshData()
        }
    },
    mounted() {
        // this.refreshData();
    },
    methods: {
        ...mapActions(['gotoTeamSettings', 'gotoEmployee', 'gotoAppStats', 'gotoApp', 'updateSelections', 'gotoEmployeeSettings']),

        async changeLabel(labelId) {
            this.selectedClassificationNewLabel = labelId

            if (this.$store.state.historyPreference)
                this.saveClassificationLabelChangesConfirm(this.$store.state.historyPreference === 'history').catch(console.log)
            else {
                this.$refs.classificationDlg.showDlg()
            }
        },

        async saveClassificationLabelChangesConfirm(updateHistorical = false) {
            const selectedClassification = this.selectedClassification
            const loadingMatch = selectedClassification.match
            const defaultLabel = this.selectedClassificationNewLabel
            try {
                this.loadingClassifications.push(selectedClassification.match)
                const editMap = new StatusMap({match: selectedClassification.match, defaultLabel: defaultLabel})
                const {_id} = await editMap.updateDefault(updateHistorical);
                selectedClassification.label = defaultLabel
                arrSplice(this.loadingClassifications, (match) => match === loadingMatch)
                if (updateHistorical)
                    this.refreshData(false)
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
                arrSplice(this.loadingClassifications, (match) => match === loadingMatch)
            }
        },

        classificationMenuClicked(e, classification) {
            this.selectedClassification = classification;
            const params = e.target.getBoundingClientRect();
            this.showClassificationMenu = false
            this.$nextTick(() => {
                this.classificationX = (params.left + params.width) - 200
                this.classificationY = params.bottom
                this.showClassificationMenu = true
            })
        },

        async refreshData(enableLoading = true) {
            try {
                if (enableLoading)
                    this.loading = true;
                this.stats = await this.$newReq('POST', 'dashboard/getTeamStats', {
                    start: this.start,
                    end: this.end,
                    deviceIds: this.devices.map(obj => obj._id).filter(deviceId => this.devicesWithAccessIds.includes(deviceId))
                })
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                if (enableLoading)
                    this.loading = false
            }
        }
    },
    computed: {
        ...mapGetters(['teamsRef', 'teamsRef', 'devicesByEmployee', 'labelsRef', 'labels','employeesByTeam', 'access', 'devicesWithAccessIds']),
        topAppTableHeadersWithAccess() {
            const cols = this.topAppTableHeaders
            return this.access.classification
                    ? cols.concat({text: '', value: 'actions', sortable: false, align: 'center', width: 30})
                    : cols
        },
        timePerformanceChartData() {
            const timeNames = this.stats.timePerformance.map(obj => {
                // return obj._id % 1800 === 0 ? obj.name : ''
                return obj.name
            })

            const neutralSeries = this.stats.timePerformance.map(obj => obj.ntt)
            const productiveSeries = this.stats.timePerformance.map(obj => obj.ptt)
            const unproductiveSeries = this.stats.timePerformance.map(obj => obj.utt)

            const series = [
                {
                    name: 'Neutral',
                    data: neutralSeries,
                    fillColor: this.labelsRef[0].cssColor
                }, {
                    name: 'Productive',
                    data: productiveSeries,
                    fillColor: this.labelsRef[1].cssColor
                }, {
                    name: 'Unproductive',
                    data: unproductiveSeries,
                    fillColor: this.labelsRef[2].cssColor
                }
            ]

            const chartOptions = {

                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {enabled: false},
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    colors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor],
                    dashArray: [0, 0, 0],
                    width: 2
                },
                grid: {
                    show: true,
                    borderColor: 'var(--v-primary-base)',
                    strokeDashArray: 0,
                    position: 'back',
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                xaxis: {
                    categories: timeNames,
                    labels: {
                        rotate: -60,
                        rotateAlways: true,
                        style: {
                            colors: timeNames.map(() => '#fff'),
                        },
                    },
                    axisBorder: {
                        show: true,
                        color: 'var(--v-primary-base)',
                        height: 1,
                    },
                },
                tooltip: {
                    enabled: false,
                    theme: 'dark',
                    y: {
                        formatter: function (val) {
                            return durationDisplay(val)
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                },
                yaxis: {
                    show: true,
                    title: {
                        text: 'Activity'
                    },
                    labels: {
                        show: false,
                    },
                },
                legend: {
                    markers: {
                        fillColors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor]
                    },
                    labels: {
                        colors: ['#fff']
                    },
                },
                colors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor],
            }

            return {
                series,
                chartOptions,
            }
        },
        employeePerformanceChartData() {
            const employeeNames = this.stats.employeePerformance.map(obj => obj.name)

            const neutralSeries = this.stats.employeePerformance.map(obj => obj.ntt)
            const productiveSeries = this.stats.employeePerformance.map(obj => obj.ptt)
            const unproductiveSeries = this.stats.employeePerformance.map(obj => obj.utt)


            const series = [
                {
                    name: 'Neutral',
                    data: neutralSeries,
                    fillColor: this.labelsRef[0].cssColor
                }, {
                    name: 'Productive',
                    data: productiveSeries,
                    fillColor: this.labelsRef[1].cssColor
                }, {
                    name: 'Unproductive',
                    data: unproductiveSeries,
                    fillColor: this.labelsRef[2].cssColor
                }
            ]

            const chartOptions = {
                grid: {
                    show: true,
                    borderColor: 'var(--v-primary-darken4)',
                    strokeDashArray: 0,
                    position: 'back',
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '65%',
                        // endingShape: 'rounded',
                        borderRadius: 3,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    },
                },
                dataLabels: {
                    enabled: false,
                    formatter: function (val) {
                        return hourDisplay(val);
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#fff"]
                    }
                },
                stroke: {
                    show: true,
                            width: 2,
                            colors: ['transparent']
                },
                xaxis: {
                    categories: employeeNames,
                    show: true,
                    rotate: -45,
                    rotateAlways: false,
                    labels: {
                        style: {
                            colors: employeeNames.map(() => '#fff'),
                        },
                    },

                    axisBorder: {
                        show: true,
                        color: 'var(--v-primary-base)',
                        height: 1,
                    },
                },
                yaxis: {
                    show: true,
                    title: {
                        text: 'Time Active (hours)'
                    },
                    labels: {
                        show: true,
                        align: 'right',
                        style: {
                            colors: ['#FFF'],
                            fontSize: '14px',
                            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                        },
                        formatter: (value) => { return `${(value / 3600).toFixed(2)}`},
                    },
                },
                fill: {
                    type: 'solid',
                    colors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor]
                },

                tooltip: {
                    enabled: true,
                    theme: 'dark',
                    style: {
                        fontSize: '12px',
                        fontFamily: undefined
                    },
                    y: {
                        formatter: function (val) {
                            return durationDisplay(val)
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                    marker: {
                        show: true,
                    },
                },

                legend: {
                    markers: {
                        fillColors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor]
                    },
                    labels: {
                        colors: ['#fff']
                    },
                }
            }

            return {
                series,
                chartOptions,
            }
        },
        productivityChartData() {


            const totalTime = this.stats.summary.ptt
                    + this.stats.summary.ntt
                    + this.stats.summary.utt
                    + this.stats.summary.idleTime

            const series = [
                {
                    label: 'Productive',
                    val: Math.floor((this.stats.summary.ptt / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.ptt / totalTime) * 100) || 0.2 : 0.2,
                    color: this.labelsRef[1].cssColor
                },
                {
                    label: 'Neutral',
                    val: Math.floor((this.stats.summary.ntt / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.ntt / totalTime) * 100) || 0.2 : 0.2,
                    color: this.labelsRef[0].cssColor
                },
                {
                    label: 'Unproductive',
                    val: Math.floor((this.stats.summary.utt / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.utt / totalTime) * 100) || 0.2 : 0.2,
                    color: this.labelsRef[2].cssColor
                },
                {
                    label: 'Idle',
                    val: Math.floor((this.stats.summary.idleTime / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.idleTime / totalTime) * 100) || 0.2 : 0.2,
                    color: '#607D8B'
                },
            ]

            const seriesNames = series.map(obj => obj.label)
            const seriesData = series.map(obj => obj.val)
            const seriesColors = series.map(obj => obj.color)

            const chartOptions = {
                chart: {
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        inverseOrder: true,
                        hollow: {
                            margin: 10,
                            size: '46%',
                            background: 'transparent',
                        },
                        track: {
                            show: false,
                        },
                        startAngle: -180,
                        endAngle: 180
                    },
                },
                fill: {
                    type: 'solid',
                    colors: seriesColors
                },
                stroke: {
                    lineCap: 'round'
                },
                // series: seriesData,
                labels: seriesNames,
                legend: {
                    show: true,
                    floating: false,
                    position: 'top',
                    // offsetX: 70,
                    // offsetY: 208,
                    labels: {
                        colors: ['#fff']
                    },
                    markers: {
                        fillColors: seriesColors
                    }
                },

            }
            return {
                seriesData: seriesData,
                chartOptions,
            }
        },
        topAppsChartData() {

            const series = [...this.stats.topApps].sort((a, b) => a.label > b.label ? 1 : -1)

            const seriesNames = series.map(obj => obj.match)
            const seriesData = series.map(obj => obj.totalDuration)
            const seriesColors = series.map(obj => this.labelsRef[obj.label].cssColor)

            const chartOptions = {
                labels: seriesNames,
                grid: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                    background: {
                        enabled: false,
                    },
                    style: {colors: ['#fff']},
                    dropShadow: {enabled: false,},
                    formatter: function (val, opts) {
                        return hourDisplay(seriesData[opts.seriesIndex])
                    },
                },
                stroke: {
                    opacity: 0,
                    colors: seriesColors,
                    width: 0
                },
                fill: {
                    opacity: 1,
                    colors: seriesColors
                },
                chart: {
                    type: 'donut',
                },
                legend: {show: false,},
                yaxis: {show: false},
                plotOptions: {
                    polarArea: {
                        rings: {
                            strokeWidth: 0
                        },
                        spokes: {
                            strokeWidth: 0
                        },
                    }
                },
                tooltip: {
                    fillSeriesColor: true,
                    custom: function ({series, seriesIndex, dataPointIndex, w}) {
                        return ` <div class="pa-1"> <div class="caption">${seriesNames[seriesIndex]}</div> <div class="body-1 text-right">${durationDisplay(seriesData[seriesIndex])}</div> </div> `
                    }
                },
                // theme: {
                //     mode: 'dark',}
            }
            return {
                seriesData,
                chartOptions,
            }
        },
        shownCards() {
            return this.$store.state.ref.teamStats.selectedCards.filter(val => val !== "productivityWorkTime" && val !== "workTime").map(key => {
                const card = {
                    key,
                    info: this.cards.filter(card => card.value === key).pop(),
                    val: (() => {
                        switch (key) {
                            case 'productivityTarget':
                                return percentDisplay(this.stats.summary[key])
                            case 'productivityActive':
                                return percentDisplay(this.stats.summary[key])
                            case 'productivityNormalTarget':
                                return percentDisplay(this.stats.summary[key])
                            default:
                                return durationDisplayFull(this.stats.summary[key])
                        }
                    })(),
                    // valDesc: (() => {
                    //     if (['productivityTarget', 'productivityActive'].includes(key))
                    //         return null
                    //     return hourDisplay(this.stats.summary[key])
                    // })(),
                }
                return card
            })
        },
        employees() {
            return [...this.employeesByTeam[this.team._id]].sort(nameSort)
        },
        devices() {
            return this.employees.reduce((list, emp) => {
                return this.devicesByEmployee[emp._id] ? list.concat(this.devicesByEmployee[emp._id]) : list
            }, []);
        },
        team() {
            return this.teamsRef[this.$store.state.ref.teamStats.selectedTeam];
        },
        start() {
            return this.$store.state.ref.dashboard.selectedRange.start
        },
        end() {
            return this.$store.state.ref.dashboard.selectedRange.end
        },
        dateTitle() {
            // TODO Add Here
            // if (this.range.title)
            //     return this.range.title
            if (!isSameYear(this.range.start, this.range.end))
                return `${format(this.range.start,'dd MMM yyyy')} - ${format(this.range.end,'dd MMM yyyy')}`
            if (!isSameMonth(this.range.start, this.range.end))
                return `${format(this.range.start,'dd MMM')} - ${format(this.range.end,'dd MMM yyyy')}`
            if (!isSameDay(this.range.start, this.range.end))
                return `${format(this.range.start,'dd')} - ${format(this.range.end,'dd MMM yyyy')}`
            return format(this.range.end,'dd MMM yyyy')
        },
        range() {
            return this.$store.state.ref.dashboard.selectedRange
        },
        viewColumns() {

            const cols = this.employeeStatisticsHeaders.filter(header => {
                if (!this.$store.state.ref.dashboard.employeesSelectedColumns.length)
                    return true
                return this.$store.state.ref.dashboard.employeesSelectedColumns.includes(header.value)
            })

            return this.access.setup ? cols.concat({
                text: '',
                value: 'actions',
                sortable: false,
                align: 'center',
                width: 30
            }) : cols
        }
    },
}
</script>

<style scoped>

</style>